import { render, staticRenderFns } from "./jf-gaestekarten.vue?vue&type=template&id=3591fe84&scoped=true&lang=pug&"
import script from "./jf-gaestekarten.vue?vue&type=script&lang=js&"
export * from "./jf-gaestekarten.vue?vue&type=script&lang=js&"
import style0 from "./jf-gaestekarten.vue?vue&type=style&index=0&id=3591fe84&lang=sass&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3591fe84",
  null
  
)

export default component.exports